// _landing — a pathless layout shared by /join-us, /sign-in, and /get-started.
// It renders ONE persistent JoinLanding; the matched child path (below) only
// tells JoinLanding which inline module to open (none / sign-in / join). Because
// the layout stays mounted while navigating between its children, opening or
// closing a module changes the URL WITHOUT remounting the landing (no hero/video
// reload) — and browser back naturally closes the module. Signed-in visitors are
// bounced to the feed, same as the standalone flows used to be.

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { JoinLanding } from '@/components/landing';
import { redirectIfSignedIn } from '@/lib/use-session';

export const Route = createFileRoute('/_public/_landing')({
  beforeLoad: ({ context }) => redirectIfSignedIn(context),
  component: LandingLayout,
});

function LandingLayout() {
  return (
    <>
      <JoinLanding />
      {/* The child routes render nothing — they exist only to own the path. */}
      <Outlet />
    </>
  );
}
